import $ from 'jquery';
// Set The height of the parsys
function setHeightOfTheParsys(height) {
    var apireferenceElement = document.getElementsByClassName("parsys");
    if (apireferenceElement.length > 0) {
        apireferenceElement[0].style.height = height + "px";
    }
}
// Set Height of the developer wrapper according to the height of the rhs
function setHeightOfDeveloperWrapper() {
    var rhsContentElement = document.getElementById("dynamic-rhs");
    var apireferenceElement = document.getElementsByClassName("css-1o7jus8-closedStyles-closedStyles");
    var plain_height = rhsContentElement[0].clientHeight;

    if ($(window).width() <= 991) {
        plain_height = plain_height - 100;
    }
    // This code gets executed only with the integrated  api reference page
    if (apireferenceElement.length > 0) {
        apireferenceElement[0].style.height = plain_height + "px";
    }
}

// Set Height of the developer wrapper according to the height of the rhs
function setHeightOfDeveloperWrapperForRequestAndResponseField() {
    var docContainerHeight = document.getElementsByClassName("bs-docs-section");
    if (docContainerHeight.length > 0) {
        var height = docContainerHeight[0].clientHeight;
        var rhsContentElement = document.getElementsByClassName("RHSContent");
        var apireferenceElement = document.getElementsByClassName("parsys");
        height = height + 100;

        // This code gets executed only with the integrated  api reference page

        if (apireferenceElement.length > 0) {
            if ($(window).width() <= 991) {
                apireferenceElement[0].style.height = height + computeHeightOfLHS() + 40 + "px";
                apireferenceElement[0].clientHeight = height + computeHeightOfLHS() + 40 + "px";
            } else {
                apireferenceElement[0].style.height = height + "px";
                apireferenceElement[0].clientHeight = height + "px";
            }

            if ($(window).width() <= 991) {
                height = height - 100;
            }
            rhsContentElement[0].clientHeight = height + "px";
            rhsContentElement[0].style.height = height + "px"
        }
    }
}

// Compute The height for lhs menu
function computeHeightOfLHS() {
    var height = 0;
    var element = document.getElementsByClassName("ApiFamilyHeader");
    for (var i = 0; i < element.length; i++) {
        height = height + element[i].clientHeight;
    }
    return height;
}

// Compute Height Dynamically according to height of the authentication or static section
function computeHeightDynamicallyForHomeSection() {
    // initial height of padding top and documentation label
    var computedHeight = 0;
    var featurehighlightlist = document.getElementsByClassName("home-section-tiles");
    if (featurehighlightlist != null) {
        for (var i = 0; i < featurehighlightlist.length; i++) {
            computedHeight = computedHeight + featurehighlightlist[i].clientHeight;
        }
    }

    featurehighlightlist = document.getElementsByClassName("gettingstarted-section");
    if (featurehighlightlist != null) {
        for (var i = 0; i < featurehighlightlist.length; i++) {
            computedHeight = computedHeight + featurehighlightlist[i].clientHeight;
        }
    }
    var rhsContentElement = document.getElementsByClassName("RHSContent");
    rhsContentElement[0].style.height = "0px";
    rhsContentElement[0].style.height = computedHeight + "px";
    //include the height of lhs in the main height

    if ($(window).width() <= 991) {
        computedHeight = computedHeight + computeHeightOfLHS() + 100;
    }
    setHeightOfTheParsys(computedHeight);
}

// Compute Height Dynamically according to height of the authentication or static section
function computeHeightDynamicallyForAuthenticationSection() {
    // initial height of padding top and documentation label
    var computedHeight = 100;
    var authenticationSection = document.getElementsByClassName("api-end-points-authentication-section");
    if (authenticationSection) {
        computedHeight = computedHeight + authenticationSection[0].clientHeight;
    }

    var rhsContentElement = document.getElementsByClassName("RHSContent");
    rhsContentElement[0].style.height = "0px";
    rhsContentElement[0].style.height = computedHeight + "px";
    //include the height of lhs in the main height

    if ($(window).width() <= 991) {
        computedHeight = computedHeight + computeHeightOfLHS() + 100;
    }
    setHeightOfTheParsys(computedHeight);
}

// This function is to adjust height after json data is being fetched
function computeHeightAfterJsonDataFetch() {
    var list = document.getElementsByClassName("bs-docs-section");
    var computedHeight = 0;
    if (list.length > 0) {
        computedHeight = computedHeight + list[0].clientHeight + 80;
        var rhsContentElement = document.getElementsByClassName("RHSContent");
        if ($(window).width() > 991) {
            rhsContentElement[0].style.height = "0px";
            rhsContentElement[0].style.height = computedHeight + list.length * 20 + "px";
            setHeightOfDeveloperWrapper();
        }

        //include the height of lhs in the main height
        if ($(window).width() <= 991) {
            var rhselementHeight = document.getElementById("RhsContents");
            rhsContentElement[0].style.height = "0px";
            rhsContentElement[0].style.height = rhselementHeight.clientHeight + "px";
            var listItems = document.getElementsByClassName("bs-docs-sidebar");
            var lhsHeight = listItems[0].clientHeight + 120;
            var lhsmenuContents = document.getElementById("lhsmenucontents");
            if (lhsmenuContents.style.display == "block") {
                lhsHeight = lhsHeight + 200;
            }
            computedHeight = rhselementHeight.clientHeight + lhsHeight + 120;
            setHeightOfTheParsys(computedHeight);
        }
    }

}


// Compute Height Dynamically according to height of the contents in rhs
function computeHeightDynamically() {
    // initial height of padding top and documentation label
    var computedHeight = 350;
    var list = document.getElementsByClassName("Api-names");
    for (var i = 0; i < list.length; i++) {
        computedHeight = computedHeight + list[i].clientHeight;
    }
    computedHeight = computedHeight + list.length * 110;
    var rhsContentElement = document.getElementsByClassName("RHSContent");
    rhsContentElement[0].style.height = "0px";
    rhsContentElement[0].style.height = computedHeight + list.length * 20 + "px";
    setHeightOfDeveloperWrapper();
    return computedHeight + 100;
}

// Function to compute Height Dynamically For Request Field Description
function computeHeightDynamicallyForRequestFieldDescription() {
    var computedHeight = 0;
    var list = document.getElementsByClassName("req-res-description");
    for (var i = 0; i < list.length; i++) {
        computedHeight = computedHeight + list[i].clientHeight - 222;
    }
    return computedHeight;
}




// executes when complete page is fully loaded, including all frames, objects and images
function displayReferenceContainer() {
    var element = document.getElementById("mainContent");
    element.style.display = "block";
}

// Compute The height for lhs menu
function computeHeightOfId(id) {
    var height = 0;
    var element = document.getElementById(id);
    if(element != null)
    {
        height = height + element.clientHeight;
    }
    return height;
}

function setHeighOfId(sourceElement,height)
{
    var sourceElement = document.getElementById(sourceElement);

    if(sourceElement != null)
    {
        sourceElement.style.height = height + "px";
    }
}

function computeHeightOfHeaderForRhs()
{
    if ($(window).width() < 991)
    {
      var height = 0;
      height = height + computeHeightOfId("nav-bar") + computeHeightOfId("headerExample") + computeHeightOfId("summarySection") + computeHeightOfId("LiveConsole") + computeHeightOfId("Request Field Description") + computeHeightOfId("Response Field Description");
      if(height > 0)
      {
        setHeighOfId("dynamic-rhs",height);
      }
    
    }
}

export default setHeightOfDeveloperWrapper;
export {setHeightOfDeveloperWrapper,computeHeightOfId,setHeighOfId,computeHeightOfHeaderForRhs};